import { PALETTE } from "../indicators/palette";
import { DRAWING_DEFAULT_COLOR, DRAWING_DEFAULT_WIDTH_PX } from "./drawingConstants";
import { DRAWING_LEVEL_FORMAT } from "./drawingLevels";

/** What a field of the style holds: what is saved of it is checked by this (settings/savedDrawings.js). */
export const STYLE_FIELD = {
  COLOR: "color",
  FLAG: "flag",
  LEVEL_FORMAT: "levelFormat",
  LEVELS: "levels",
};

/**
 * @param {*} value
 * @returns {boolean} whether it can be an offset of a pitchfork level
 */
export const isValidLevelValue = (value) => Number.isFinite(value) && value > 0;

/**
 * What a tool has in its style beyond colour and width (po-chart-visual-spec.md §7.5): `fields` by their
 * STYLE_FIELD, `defaults` gets `colorOf(PALETTE name) → CSS colour` (the colours come from the theme).
 */
export const BACKGROUND_STYLE = {
  fields: { isBackgroundVisible: STYLE_FIELD.FLAG, backgroundColor: STYLE_FIELD.COLOR },
  defaults: (colorOf) => ({ isBackgroundVisible: true, backgroundColor: colorOf(DRAWING_DEFAULT_COLOR) }),
};

export const FIBONACCI_FAN_STYLE = {
  fields: { isLevelsVisible: STYLE_FIELD.FLAG, levelsColor: STYLE_FIELD.COLOR },
  defaults: (colorOf) => ({ isLevelsVisible: true, levelsColor: colorOf(PALETTE.SILVER) }),
};

export const FIBONACCI_RETRACEMENT_STYLE = {
  fields: {
    ...FIBONACCI_FAN_STYLE.fields,
    levelFormat: STYLE_FIELD.LEVEL_FORMAT,
    isValuesVisible: STYLE_FIELD.FLAG,
    valuesColor: STYLE_FIELD.COLOR,
  },
  defaults: (colorOf) => ({
    ...FIBONACCI_FAN_STYLE.defaults(colorOf),
    levelFormat: DRAWING_LEVEL_FORMAT.VALUES,
    isValuesVisible: true,
    valuesColor: colorOf(DRAWING_DEFAULT_COLOR),
  }),
};

const PITCHFORK_LEVELS = [
  { value: 0.382, colorName: PALETTE.YELLOW, isVisible: false },
  { value: 0.618, colorName: PALETTE.ORANGE, isVisible: false },
  { value: 1, colorName: PALETTE.PUMPKIN, isVisible: true },
  { value: 1.5, colorName: PALETTE.RED, isVisible: false },
  { value: 2, colorName: PALETTE.LIME, isVisible: true },
];

/** The median has `color` and `width` of the style, so the drawing toolbar changes it. */
export const PITCHFORK_STYLE = {
  fields: { isMedianVisible: STYLE_FIELD.FLAG, levels: STYLE_FIELD.LEVELS, isBackgroundVisible: STYLE_FIELD.FLAG },
  defaults: (colorOf) => ({
    color: colorOf(PALETTE.RED),
    isMedianVisible: true,
    isBackgroundVisible: true,
    levels: PITCHFORK_LEVELS.map(({ value, colorName, isVisible }) => ({
      value,
      color: colorOf(colorName),
      width: DRAWING_DEFAULT_WIDTH_PX,
      isVisible,
    })),
  }),
};

/** The number of the levels of a pitchfork never changes, so a saved list is whole or left out. */
export const PITCHFORK_LEVEL_COUNT = PITCHFORK_LEVELS.length;
